import { ProposalsResponseModel } from '@fh-client-interaction-frontends/fh-sales-portal-service';
import {
  ProposalBillingResponseInterface
} from '../../../../interfaces/response/client-portal/proposal-billing/proposal-billing-response-interface';
import {
  ProposalBillingRequestModel
} from '../../../request/client-portal/proposal-billing/proposal-billing-request-model';

export class ProposalBillingResponseModel implements ProposalBillingResponseInterface {
  campaignAppliedTo?: string;
  campaignDurationMonths?: number;
  campaignValueOrPercentual?: number;
  charge: number = 0;
  firstPaymentTotalValue: number = 0;
  firstPaymentValue: number = 0;
  numberFractionsYear: number = 0;
  totalValue: number = 0;
  totalWithDiscount: number = 0;
  value: number = 0;
  gift:boolean= false;

  constructor(init?: Partial<ProposalBillingRequestModel>) {
    Object.assign(this, init);
  }
}
